import { View } from 'react-native'
import SafePressable from '@ui/buttons/SafePressable'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import { StepOption, StepOptions } from '@order/steps/types'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import useAnimatedPress from '@ui/animated/useAnimatedPress'

interface Props {
  title?: string
  desc?: string
  options: StepOptions
}

const TileOption = ({ option }: { option: StepOption }) => {
  const { t } = useTranslation(['ui'])
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const onPress = option.onPress

  return (
    <SafePressable onPress={onPress} onPressIn={onPressIn} onPressOut={onPressOut}>
      <TileBlur
        variant="option"
        key={option.id}
        title={option.title}
        desc={option.desc}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label={t('ui:select')}
          />
        }
        glassProps={{
          image: option.image,
          imageWrapperStyle: {
            width: '95%',
            height: '95%',
          },
          animation,
          imageStyle: {
            opacity: 1,
            transform: [{ translateX: -50 }, { translateY: 1 }],
          },
          blurMode: 'backdropFilter',
          blurStyle: {
            opacity: 0.75,
            transform: [{ translateX: 0 }, { translateY: 0 }, { scale: 0.75 }],
          },
        }}
      />
    </SafePressable>
  )
}

export default function TilesTemplate({ title, desc, options }: Props) {
  const { t } = useTranslation(['ui'])

  return (
    <Page stage="configuration">
      <Header title={title} desc={desc} />
      <View className="gap-8 px-8">
        {options.map((option) => (
          <TileOption key={option.id} option={option} />
        ))}
      </View>
    </Page>
  )
}
